import GambleModel from "slotworks/model/gamble/gamble-model";
import GameState from "slotworks/model/game-state";
import RequestPayload from "slotworks/model/gameplay/requests/request-payload";
import SpinRecord from "../records/spin-record";

export default class GambleRequestPayload extends RequestPayload {
    public choice?: string = GambleModel.getCurrentChoice();
    public id: number = (GameState.getCurrentGame().getCurrentRecord() as SpinRecord).gambleID;
}
